import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import HomeworkTracking from './components/HomeworkTracking';
import Reports from './components/Reports';
import Forum from './components/Forum';
import TeacherForum from './components/TeacherForum';
import Messaging from './components/Messaging';
import TeacherMessaging from './components/TeacherMessaging';
import { OgretmenProfil } from './components/OgretmenProfil';
import { OgretmenBildirimler } from './components/OgretmenBildirimler';
import { ToastProvider } from './components/Toast';
import { UserProvider } from './components/UserContext';
export function App() {
  return <UserProvider data-id="element-0">
      <ToastProvider data-id="element-1">
        <Router data-id="element-2">
          <Layout data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
              <Route path="/homework" element={<HomeworkTracking data-id="element-8" />} data-id="element-7" />
              <Route path="/reports" element={<Reports data-id="element-10" />} data-id="element-9" />
              <Route path="/forum" element={<Forum data-id="element-12" />} data-id="element-11" />
              <Route path="/teacher-forum" element={<TeacherForum data-id="element-14" />} data-id="element-13" />
              <Route path="/messages" element={<Messaging data-id="element-16" />} data-id="element-15" />
              <Route path="/teacher-messages" element={<TeacherMessaging data-id="element-18" />} data-id="element-17" />
              <Route path="/profile" element={<OgretmenProfil data-id="element-20" />} data-id="element-19" />
              <Route path="/notifications" element={<OgretmenBildirimler data-id="element-22" />} data-id="element-21" />
              <Route path="*" element={<Navigate to="/" data-id="element-24" />} data-id="element-23" />
            </Routes>
          </Layout>
        </Router>
      </ToastProvider>
    </UserProvider>;
}